module.exports = __webpack_public_path__ + "img/audi-event2.fae27b83.jpg";